﻿$.fn.dxCtrlContentEmailFichier = function custom_dxCtrlContentEmailFichier(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentemailfichier dx-ctrl");
        this.createInstance(new cdxCtrlContentEmailFichier(this, option));
    }
    return this;
}

window.cdxCtrlContentEmailFichier = function (container, option) {
    var Me = this;
    if (typeof option.allowCorbeille == 'undefined') option.allowCorbeille = true
    if (typeof option.allowDuplik == 'undefined') option.allowDuplik = true
    if (typeof option.openDuplik == 'undefined') option.openDuplik = true

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    this.isDirty = function (value) {
        if (typeof value != 'undefined') dxContentEmailBase.isDirty(value)
        return dxContentEmailBase.isDirty()
    }

    var dxContentEmailBase = null
    //var dxPopupInterneClose = null
    var isNew = false
    var dxBtImportInEmail = null
    function mConstruit() {
        container.empty()

        isNew = (option.data.id_fichier == null)

        var popupPage = page.mGetPopupPage(option.data)
        if (popupPage != null) {
            var onbeforeclose = popupPage.option("onBeforeClose")
            popupPage.option("onBeforeClose", function (e) {
                ////if (dxContentEmailBase.isDirty()) {
                ////    dxContentEmailBase.mSaveAuto(function () { return mFin() })
                ////} else { return mFin() }
                ////function mFin() {
                //if (isNew && option.data.id_fichier != null && dxPopupInterneClose == null) {
                //    mSaveNewAndQuitte()
                //    return false
                //} else {
                if (dxContentEmailBase != null && dxContentEmailBase.isDirty()) {
                    dxContentEmailBase.mStopSaveAuto()
                }
                if (typeof onbeforeclose != 'undefined') { return onbeforeclose(e) }
                else { return true }
                //}
                ////}
            })
        }

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow();

        mRempliBt()

        var firstLoad = true;
        dxContentEmailBase = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlContentEmailBase({
            bddCtrl: option.bddCtrl,
            data: option.data,
            readOnly: false,
            saveAuto: true,
            allowFullScreen: true,
            onDemandeUrl: function (funcFin) {
                dxContentEmailBase.mSaveAuto(function () {
                    option.bddCtrl.mAjaxCall({ command: "getemailurl", path_nom_fichier: option.data.id_fichier }, function (data) {
                        funcFin(data.url)
                    })
                })
            },
            onSave: function () {
                option.data.id_fichier = dxContentEmailBase.option("path_nom_fichier")
                mRempliPath()
            },
            onContentReady: function () {
                if (firstLoad) {
                    firstLoad = false
                    jauge.mHide();
                    dxContentEmailBase.focus()
                    //Sauvegarde pour les nouveau fichiers
                    if (typeof option.data.id_fichier == 'undefined' || option.data.id_fichier == null) dxContentEmailBase.mSave()
                    mRempliTaille()
                }
            }
        }).dxCtrlContentEmailBase("instance")
    }

    var $DivPath = null
    var eleTaille = null
    var lstItemToolBarSource = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []

        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'never',
            width: "100%",
            template(itemData, itemIndex, itemElement) {
                $DivPath = itemElement
                itemElement.addClass("state-hover")
                mRempliPath()
                //var obj = option.bddCtrl.getObjet({ id_fichier: option.data.id_fichier })
                //itemElement.html("<table style='width:100%;table-layout:fixed'><tr><td><div style='font-family:barlow condensed;line-height:1;overflow: hidden;text-overflow: ellipsis;white-space:nowrap;'><span style='opacity:0.3;'/>" + obj.mGetPathDocument() + "/</span><br/><span style='opacity:0.8;'>" + obj.mGetNom() + "</span></td></tr></table>")
                //itemElement.attr("title", "<div style='text-align:left;'>" + obj.mGetPathDocument() + "/<br/>" + obj.mGetNom() + "</div>")
            }
        })
        itemsToolbar.push(getToolbarSeparator())

        //taille
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'never',
            width: "100%",
            template(itemData, itemIndex, itemElement) {
                eleTaille = $("<span style='font-size:80%;' title='" + "'>" + "</span>").appendTo(itemElement)
                mRempliTaille()
            }
        })
        itemsToolbar.push(getToolbarSeparator())


        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-paper-plane",
                    icon2: "fas fa-vial",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Tester votre message en l'envoyant<br/>sur des adresses emails saisies.",
                    onClick: function (e) {
                        $("<div/>").appendTo("body").dxCtrlPopupSaisieEmailTest({
                            bddCtrl: option.bddCtrl,
                            onValidate: function (lstEmail) {
                                jaugeDemarrage.mShow();
                                jaugeDemarrage.option("message", "Génération et envoi du mail de test")

                                dxContentEmailBase.mSaveAuto(function () { mTest() })
                                function mTest() {
                                    option.bddCtrl.mAjaxCall({ command: "getdatafichieremlz", id_fichier: option.data.id_fichier, externe: "1" },
                                        function (data) {
                                            debugger;
                                            option.bddCtrl.getObjet("com_email_envoi").objetMetier.mCreateEmailBrouillon("[TEST] " + data.objet, data.html, (typeof data.lstfile != 'undefined' ? data.lstfile : []), [], null, false, null, true, null, false, "", function (idComEmailEnvoi) {
                                                var objs = option.bddCtrl.getObjets()
                                                lstEmail.forEach(function (adresseEmail) {
                                                    var newDataComDest = option.bddCtrl.getObjet("com_destinataire").mGetNewData()
                                                    newDataComDest.id_type_destinataire = 1
                                                    newDataComDest.id_table_com = option.bddCtrl.table.mGetItemFromNom("com_email_envoi").id_table
                                                    newDataComDest.id_com = idComEmailEnvoi
                                                    newDataComDest.id_table_destinataire = null
                                                    newDataComDest.id_destinataire = null
                                                    newDataComDest.adresse_email = adresseEmail
                                                    objs.mAddData([newDataComDest], "save")
                                                })
                                                objs.mSave(function (data) {
                                                    var objComEmailEnvoiDuplik = option.bddCtrl.getObjet("com_email_envoi", idComEmailEnvoi)

                                                    objComEmailEnvoiDuplik.data.date_envoi = parametre.dateNow
                                                    objComEmailEnvoiDuplik.data.id_type_classement = 13
                                                    objComEmailEnvoiDuplik.data.ignore_attente_compte_email = "1"
                                                    objComEmailEnvoiDuplik.mSave(function (data) {
                                                        //on attend que l'envoi soit fait pour supprimer le mail à la fin
                                                        mVerifTestEmail()

                                                        function mVerifTestEmail() {
                                                            var objComEmailEnvoiDuplik = option.bddCtrl.getObjet("com_email_envoi", idComEmailEnvoi)
                                                            if (objComEmailEnvoiDuplik.data.id_type_classement == 10 || objComEmailEnvoiDuplik.data.id_type_classement == 12) {
                                                                ////l'email de test a été envoyé
                                                                //objComEmailEnvoiDuplik.mDelDataDefinitif(function () { })
                                                                mNotify("Votre email de test à été envoyé", "success", 6000)
                                                                jaugeDemarrage.mHide();
                                                                jaugeDemarrage.option("message", null)
                                                            } else {
                                                                //l'email est en attente d'envoi
                                                                window.setTimeout(function () { mVerifTestEmail() }, 1000)
                                                            }
                                                        }
                                                    })
                                                })
                                            })
                                        })
                                    //option.bddCtrl.getObjet("com_email_envoi").objetMetier.mCreateEmailBrouillon(
                                    //    "", "", [],
                                    //    [{ id_table: idTable, id: id, adresse_email: adresseEmail }],
                                    //    option.bddCtrl.paraAppli.mGetPara(keyParaAppli),
                                    //    true, null, true, null, false, function (idComEmailEnvoi) {
                                    //        option.bddCtrl.getObjet("com_email_envoi", idComEmailEnvoi).objetMetier.mSendImmediatement()
                                    //        mFin()
                                    //    })
                                    //option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi).objetMetier.mSendEmailTest(lstEmail, function () {
                                    //    jauge.mHide();
                                    //    if (option.bddCtrl.isDemo) {
                                    //        mNotify("Vous êtes dans un environnement de démo<br/>L'envoi de votre email a été simulé et celui-ci n'a pas été réellement envoyé", "warning", 6000)
                                    //    } else {
                                    //        mNotify("Votre email de test a été envoyé.", "success", 6000)
                                    //    }
                                    //})
                                }
                            }
                        })
                    }
                });
            },
        })


        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-print",
                    txtTooltip: "Imprimer",
                    onClick: function (e) {
                        dxContentEmailBase.mSaveAuto(function () {
                            jauge.mShow();
                            jauge.option("message", "Génération de l'impression")
                            option.bddCtrl.mAjaxCall({ command: "printemailfichier", id_nom_fichier: option.data.id_fichier }, function (data) {
                                if (typeof data.urlpdf != 'undefined') {
                                    if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                                    $("<div/>").appendTo("body").dxCtrlViewer({
                                        bddCtrl: option.bddCtrl,
                                        value: [data.urlpdf],
                                        indexCourant: 0
                                    })
                                }
                                jauge.mHide();
                            })
                        })
                    }
                });
            },
        })
        itemsToolbar.push(getToolbarSeparator())

        if (option.allowCorbeille) {
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-trash-alt",
                        txtTooltip: "Mettre à la corbeille",
                        onClick: function (e) {
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                target: e.component.element(),
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "25px")
                                    $("<div style='padding-bottom:15px;'>Mettre le document<br/>à la corbeille</div>").appendTo(contentElement)
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Confirmez",
                                        onClick: function (e) {
                                            tt.hide()
                                            var actionF = new cFileManagerAction(option.bddCtrl, option.data.id_fichier, "corbeille",
                                                function () {
                                                    var popupPage = page.mGetPopupPage(option.data)
                                                    if (popupPage != null) popupPage.mDestroy()
                                                    //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
                                                    //mNotify("Votre fichier a été mis à la corbeille.", "success", 6000)
                                                })
                                            actionF.mStartTraitement()
                                        }
                                    })
                                }
                            }).dxCtrlTooltip("instance");
                            tt.show();
                        }
                    });
                },
            })
        }

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)
    }

    //var dxPopupInterneClose = null
    //function mSaveNewAndQuitte() {
    //    dxPopupInterneClose = $("<div/>").appendTo(((container.closest(".dx-popup-normal").length > 0) ? $(container.closest(".dx-popup-normal")[0]) : ((container.closest(".dx-ctrlpagepopupdiv").length > 0) ? $(container.closest(".dx-ctrlpagepopupdiv")[0]) : container))).dxCtrlPopupInterne({
    //        bddCtrl: option.bddCtrl,
    //        itemTemplate: function (contentElement) {
    //            var $Div = $("<div style='font-size:200%;font-weight:bold;padding:15px;text-align:center;'>Sauver votre document email</div>").appendTo(contentElement)
    //            var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
    //            var $Tr = $("<tr/>").appendTo($Table)
    //            var $Td = $("<td style='width:50%'/>").appendTo($Tr)
    //            var $TdContainerAccordion = $("<td style='width:250px;min-width:380px;'/>").appendTo($Tr)
    //            var $Td = $("<td style='width:50%'/>").appendTo($Tr)

    //            //le ctrl gere tout sur le serveur
    //            $("<div/>").appendTo($TdContainerAccordion).dxCtrlSaveNewFile({
    //                bddCtrl: option.bddCtrl,
    //                deleteSource: true,
    //                path_nom_fichier: option.data.id_fichier,
    //                onValideSameNameFile: function (newPathNomFichier) {
    //                    var popupPage = page.mGetPopupPage(option.data)
    //                    if (popupPage != null) popupPage.mDestroy()
    //                    //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
    //                },
    //                onValideNewNameFile: function (newPathNomFichier) {
    //                    var popupPage = page.mGetPopupPage(option.data)
    //                    if (popupPage != null) popupPage.mDestroy()
    //                    //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
    //                },
    //                onCancel: function () {
    //                    option.bddCtrl.mAjaxCall({
    //                        command: "filedelete",
    //                        path_nom_fichier: option.data.id_fichier
    //                    })
    //                    var popupPage = page.mGetPopupPage(option.data)
    //                    if (popupPage != null) popupPage.mDestroy()
    //                    //$("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance").hide()
    //                }
    //            })
    //        },
    //        onClose: function () { dxPopupInterneClose = null }
    //    }).dxCtrlPopupInterne("instance")
    //}

    var pathRempli = false
    function mRempliPath() {
        if (typeof option.data.id_fichier != 'undefined' && option.data.id_fichier != null && option.data.id_fichier.length > 0) {
            if (!pathRempli) {
                $("<div/>").appendTo($DivPath).dxCtrlSaveDocFile({
                    bddCtrl: option.bddCtrl,
                    pathNomFichier: option.data.id_fichier,
                    onChangeFileName: function (pathNomFichier) {
                        option.data.id_fichier = pathNomFichier
                    }
                })
                pathRempli = true
            }
        } else { $DivPath.empty(); $DivPath.off("click"); }

        mRempliTaille()

    }

    function mRempliTaille() {
        if (typeof option.data.taille_octet != 'undefined' && eleTaille != null) {
            eleTaille.empty()
            var $Span = $("<div style='" + ((option.data.taille_octet == 0) ? "display:none;" : "") + "'>" + option.data.taille_octet.sizeFile(2, true) + "</div>").appendTo(eleTaille)
            if (option.data.taille_octet_ss_image.sizeFile(2) != option.data.taille_octet.sizeFile(2)) $Span.attr("title", "Poids message: " + option.data.taille_octet.sizeFile(2, true) + "<br/>" + "(Sans image: " + option.data.taille_octet_ss_image.sizeFile(2, true) + ")")
        }
    }

    this.isFirstInBrouillon = (option.data.id_fichier == null)

    this.element = function () { return container }

    mConstruit();
}